module.exports = {
  externalPayProviderSelector: {
    label: 'เลือกวิธีการโอนเงินอิเล็กทรอนิกส์ของคุณ:',
  },
  paymentMethodInfo: {
    achpse: 'คุณจะถูกเปลี่ยนเส้นทางไปยังเว็บไซต์ของธนาคารที่คุณเลือกเพื่ออนุมัติการหักเงิน ใช้ได้สำหรับบัญชีออมทรัพย์ บัญชีเดินสะพัด หรือบัญชีฝากอิเล็กทรอนิกส์',
    bancolombia: 'ใช้ได้สำหรับบัญชีเดินสะพัดและบัญชีออมทรัพย์ เมื่อเลือกวิธีการชำระเงินนี้ คุณจะถูกเปลี่ยนเส้นทางไปยังเว็บไซต์ Bancolombia',
  },
  fawryLabel: 'ชำระด้วย Fawry',
};
